'use client';

import configuration from '@/configuration';
import { APIProvider } from '@vis.gl/react-google-maps';

const GoogleApiProvider = ({ children }) => {
  return <APIProvider apiKey={configuration.map.key}>{children}</APIProvider>;
};

export default GoogleApiProvider;
